export function isSettingsRoute(locationLike: Pick<Location, 'pathname'>): boolean {
  const pathname = locationLike.pathname.replace(/\/+$/, '') || '/';
  return pathname === '/settings' || pathname === '/assistant/settings' || /\/settings$/.test(pathname);
}

export function settingsPath(productSegment: string = 'assistant'): string {
  // The web app is deployed with /assistant/ as its stable SPA base, kept as
  // the default so existing /assistant/settings deep links and the no-arg
  // call sites this app started with keep working unchanged. Passing a
  // product's own segment (App.tsx's PRODUCT_PATH_SEGMENT-derived value)
  // gives each product its own settings URL instead of always bouncing to
  // Assistant's.
  return `/${productSegment}/settings`;
}
